/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_copy_link_button_tooltip21 = /** @type {(inputs: {}) => string} */ () => {
	return `Embed`
};

const fr_copy_link_button_tooltip21 = /** @type {(inputs: {}) => string} */ () => {
	return `Copier le lien`
};

const de_copy_link_button_tooltip21 = /** @type {(inputs: {}) => string} */ () => {
	return `Einbetten`
};

const es_copy_link_button_tooltip21 = /** @type {(inputs: {}) => string} */ () => {
	return `Insertar`
};

const it_copy_link_button_tooltip21 = /** @type {(inputs: {}) => string} */ () => {
	return `Incorporare`
};

const ar_copy_link_button_tooltip21 = /** @type {(inputs: {}) => string} */ () => {
	return `تضمين`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const copy_link_button_tooltip21 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.copy_link_button_tooltip21(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("copy_link_button_tooltip21", locale)
	if (locale === "en") return en_copy_link_button_tooltip21(inputs)
	if (locale === "fr") return fr_copy_link_button_tooltip21(inputs)
	if (locale === "de") return de_copy_link_button_tooltip21(inputs)
	if (locale === "es") return es_copy_link_button_tooltip21(inputs)
	if (locale === "it") return it_copy_link_button_tooltip21(inputs)
	return ar_copy_link_button_tooltip21(inputs)
};
export { copy_link_button_tooltip21 as "COPY_LINK_BUTTON_TOOLTIP" }